import Component from '@glimmer/component';
import { PrismTable } from '@mylighthouse/prism-ember';
import type {
  Column,
  SegmentItem,
} from 'lumen/utils/constants/benchmark-insight/beni-table-constant-values';

import styles from './beni-table.module.css';

interface HotelBenchmarkInsightTablesBeniTableSignature {
  Args: {
    columns: Column[];
    dataTestId?: string;
    removeBorderRadius?: boolean;
    rows: SegmentItem[];
  };
}

export default class HotelBenchmarkInsightTablesBeniTable extends Component<HotelBenchmarkInsightTablesBeniTableSignature> {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get rowsBody() {
    return this.args.rows.filter((row) => !row.isTotalRow);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get rowsFooter() {
    return this.args.rows.filter((row) => row.isTotalRow);
  }

  <template>
    <div
      class="{{styles.table}}
        {{if @removeBorderRadius styles.table--no-border-radius}}"
      data-test-id={{@dataTestId}}
    >
      <PrismTable
        @columns={{@columns}}
        @footerRows={{this.rowsFooter}}
        @rows={{this.rowsBody}}
        @widthConstraint="gte-container-slack"
        data-test-id="beni-table"
      />
    </div>
  </template>
}
